import React from 'react';
import PropTypes from "prop-types";
import {
    CheckboxContent,
    CheckboxWrapperMain,
    SelectDropdownStyles,
    AccountLinkWrapper,
} from '../styles';
import { Row, Col } from 'antd';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { BasicInfo , BasicInfoMinMax } from '../styles';
import history from "../../../../../../../history/history";
import { updateLoggedinAddress } from "../../../actions";
import { CustomCheckbox } from '../../../../../../../CommonComponents/commonStyles';
import InputComponent from "../../CommonComponents/InputComponent/InputComponent";
import AddressInput from "../../CommonComponents/InputComponent/AddressInput";
import AddressDropDown from "../../CommonComponents/DropDownComponent/AddressDropDown";
import AddressInputDropDown from "../../CommonComponents/DropDownComponent/AddressInputDropDown";
import Popup from "./Popup/Popup";
import Notice from './Notice';
import {selectHeader} from "../../../../../../../actions/globalActions";
let popUpState = false;

export class AddressForm extends React.Component {
    constructor(props) {
        super(props);
        popUpState = false;
        this.updateLoggedAddress = this.updateLoggedAddress.bind(this);
    }

    updateLoggedAddress = (e) => {
            this.props.updateLoggedInAddress(e.target.checked);
    }

    navigateMyAccount = () => {
        this.props.selectHeader('My Documents');
        window.scrollTo(0,0);
        history.push('/my-account');
    }
    onExitClick = () => {
        popUpState = true;
        this.setState({
          show: true
        });
    }

    closeModal = () => {
        popUpState = false;
        this.setState({
          show: false
        });
      };

    removePopupContent = {
        heading: "Exit Make A Contribution",
        line1: "Any data entered so far on the ‘Make a Contribution’ flow will be lost.",
        line2: "Do you want to continue ?",
        continue: "continue",
        cancel: "No, take me back",
        type: "removeInfo"
      };

    showPopUp = (index) => {
        popUpState = true;
        this.setState({show: true});
    }
    
    render() {
        return (
            <>
            { this.props.type === "Private Foundation" && this.props.donorId === 0 &&
                        (<Row>
                        <Notice message="No Substantiation letter will be sent since this is a Private Foundation transfer and advisors do not get an additional deduction for this type of transfer." />
                        </Row>)
            }
                    
                { (this.props.donorId === 0) ?
                <Row>
                    <BasicInfoMinMax marginBottom="30px">Logged in advisor/authorized officer</BasicInfoMinMax>
                </Row>
                :
                <Row>
                    <BasicInfoMinMax marginTop="20px" marginBottom="20px" className="mb-25">{(this.props.type === 'Private Foundation' ? 'Private foundation' : this.props.type) + " information"}</BasicInfoMinMax>
                </Row>

                }
                {
                     ( popUpState === true && this.props.donorId === 0 ? (
                      <Popup
                       data-test='popup-mdl'
                        height="313px"
                        width="481px"
                        mwidth="88%"
                        mheight="53%"
                        content={this.removePopupContent} 
                        closeModal={this.closeModal}
                        handleRemove={() => this.navigateMyAccount()}
                      />
                    ) : null )
                }
                { ((this.props.type === "Joint") && this.props.donorId === 1 ) ?
                <>
                <Row>
                    <Col lg={{ span: 8 }} md={{ span: 8 }}>
                        <InputComponent id="txtFirstName" accountId={this.props.accountId} property="firstName" label="First Name" traverse="loggedInAdvisor" contributionType={this.props.contributionType} assetHeld={this.props.assetHeld} donorId={this.props.donorId} giftLength={this.props.count}/>
                    </Col>
                </Row>
                <Row>
                    <Col lg={{ span: 8 }} md={{ span: 8 }}>
                        <InputComponent id="txtLastName" accountId={this.props.accountId} property="lastName" label="Last Name" traverse="loggedInAdvisor" contributionType={this.props.contributionType} assetHeld={this.props.assetHeld} donorId={this.props.donorId} giftLength={this.props.count}/>
                    </Col>
                </Row>
                { (this.props.type !== "Other donor-advised fund") ? 
                <Row>
                    <Col>
                        <CheckboxWrapperMain><CustomCheckbox id="chkSameAddressAdvisor" data-test='checkbox-wrap' onChange={ e => {this.updateLoggedAddress(e)}} checked={this.props.isSameAddress} ></CustomCheckbox><CheckboxContent marginLeft="10px" >Same address as logged in advisor/donor</CheckboxContent></CheckboxWrapperMain>
                    </Col>
                </Row>
                : ""}
                </>
                :
                <>
                <Row>
                    <Col lg={{ span: 8 }} md={{ span: 8 }}>
                        <InputComponent id="txtLoggedAdvName" accountId={this.props.accountId} property="name" label={ this.props.donorId === 0 ? "Name"  : ((this.props.type === 'Private Foundation' ? 'Private foundation'  : this.props.type) +" name")} errorLabel={ this.props.type === 'Private Foundation' ? 'Private foundation name'  : this.props.type +" "+"name"} traverse="loggedInAdvisor" contributionType={this.props.contributionType} assetHeld={this.props.assetHeld} donorId={this.props.donorId} giftLength={this.props.count}/>
                    </Col>
                </Row>
                {((this.props.type === "Corporation" || this.props.type === "Private Foundation" || this.props.type === "Trust") && this.props.donorId === 1)  ? 
                <Row>
                <Col>
                    <CheckboxWrapperMain><CustomCheckbox id="chkSameAddressAdvisorWithType" data-test='checkbox-advisor' onChange={ e => {this.updateLoggedAddress(e)}} checked={this.props.isSameAddress}></CustomCheckbox><CheckboxContent marginLeft="10px">Same address as logged in advisor/donor</CheckboxContent></CheckboxWrapperMain>
                </Col>
            </Row>
            :
            null
            
            }
            </>

                }
                {
                
                (["Individual","Joint"].includes( this.props.type )||this.props.donorId == 0) ?

                 <Row>
                    <Col lg={{ span: 8 }} md={{ span: 8 }}>
                        <SelectDropdownStyles>
                        <AddressDropDown id="selAddressType" accountId={this.props.accountId} property="addressType" label="Address Type" traverse="loggedInAdvisor" contributionType={this.props.contributionType} assetHeld={this.props.assetHeld} donorId={this.props.donorId} type={this.props.type} giftLength={this.props.count} />
                        </SelectDropdownStyles>
                    </Col>
                </Row>  : null}
                <Row>
                    <Col lg={{ span: 17 }} md={{ span: 17 }}>
                        <AddressInput id="txtAddressLine1" accountId={this.props.accountId} property="line1" label="Address Line 1" traverse="loggedInAdvisor" contributionType={this.props.contributionType} assetHeld={this.props.assetHeld} donorId={this.props.donorId} giftLength={this.props.count}/>
                    </Col>
                </Row>
                <Row>
                    <Col lg={{ span: 17 }} md={{ span: 17 }}>
                        <AddressInput id="txtAddressLine2" accountId={this.props.accountId} property="line2" label="Address Line 2 (Optional)" traverse="loggedInAdvisor" contributionType={this.props.contributionType} assetHeld={this.props.assetHeld} donorId={this.props.donorId} giftLength={this.props.count}/>
                    </Col>
                </Row>
                <Row>
                    <Col lg={{ span: 17 }} md={{ span: 17 }}>
                        <AddressInput id="txtAddressLine3" accountId={this.props.accountId} property="line3" label="Address Line 3 (Optional)" traverse="loggedInAdvisor" contributionType={this.props.contributionType} assetHeld={this.props.assetHeld} donorId={this.props.donorId} giftLength={this.props.count}/>
                    </Col>
                </Row>
                <Row>
                    <Col lg={{ span: 8 }} md={{ span: 8 }}>
                        <SelectDropdownStyles>
                            <AddressInputDropDown id="selCountry" accountId={this.props.accountId} property="country" label="Country" traverse="loggedInAdvisor" contributionType={this.props.contributionType} assetHeld={this.props.assetHeld} donorId={this.props.donorId} giftLength={this.props.count}/>
                        </SelectDropdownStyles>
                    </Col>
                     <Col lg={{ span: 8 }} md={{ span: 8, offset: 1 }}>               
                         <AddressInput id="txtZipCode" accountId={this.props.accountId} property="zipCode" label="Zip Code" traverse="loggedInAdvisor" contributionType={this.props.contributionType} assetHeld={this.props.assetHeld} donorId={this.props.donorId} giftLength={this.props.count}/>
                     </Col>
                </Row>
                <Row>
                    
                    <Col lg={{ span: 8 }} md={{ span: 8 }}>
                        <AddressInput id="txtCity" accountId={this.props.accountId} property="city" label="City" traverse="loggedInAdvisor" contributionType={this.props.contributionType} assetHeld={this.props.assetHeld} donorId={this.props.donorId} giftLength={this.props.count}/>
                    </Col>
                    {(this.props.countryValue === "United States") ?
                     <Col lg={{ span: 8 }} md={{ span: 8, offset: 1 }}>
                        <SelectDropdownStyles>
                            <AddressInputDropDown id="selUSState" accountId={this.props.accountId} property="state" label="State" traverse="loggedInAdvisor" contributionType={this.props.contributionType} assetHeld={this.props.assetHeld} donorId={this.props.donorId} giftLength={this.props.count}/>
                            </SelectDropdownStyles>
                        </Col>
                            :
                        <Col lg={{ span: 8 }} md={{ span: 8, offset: 1}}>
                            <AddressInput id="txtOtherState" accountId={this.props.accountId} property="state" label="State" traverse="loggedInAdvisor" contributionType={this.props.contributionType} assetHeld={this.props.assetHeld} donorId={this.props.donorId} giftLength={this.props.count}/>
                        </Col>
                    }
                </Row>
                { (this.props.donorId == 1) ?
                <Row>
                    { this.props.type !== "Other donor-advised fund" ?
                     <Col lg={{ span: 8 }} md={{ span: 8 }}>
                        <SelectDropdownStyles>
                        <AddressDropDown id="selRelation" placeholder="Select the relationship" accountId={this.props.accountId} property="relationToDonor" label="Relation to donor/advisor" traverse="loggedInAdvisor" contributionType={this.props.contributionType} assetHeld={this.props.assetHeld} donorId={this.props.donorId} type={this.props.type} giftLength={this.props.count}/>
                        </SelectDropdownStyles>
                    </Col>
                 : '' } 
                    { (this.props.assetHeld === "assetHeldatVG" && this.props.contributionType === "mutualFund") ?
                    <Col lg={{ span: 8, offset: 1 }} md={{ span: 8, offset: 1 }}>
                        <InputComponent id="txtTaxId" accountId={this.props.accountId} property="taxIdNumber" label="Tax ID Number" traverse="loggedInAdvisor" contributionType={this.props.contributionType} assetHeld={this.props.assetHeld} donorId={this.props.donorId} giftLength={this.props.count}/>
                    </Col>
                    : '' }
                </Row>
                    : 
                <Row>
                    <BasicInfo marginBottom="20px">Update your address under <AccountLinkWrapper id="anrAccount" onClick={this.showPopUp}> Account</AccountLinkWrapper>. If you leave this screen, any data you entered will be lost.</BasicInfo>
                </Row>
                }
            </>
        )
    }
}

AddressForm.propTypes = {
    countryValue: PropTypes.string,
    isSameAddress: PropTypes.bool,
    dropdownVal : PropTypes.array,
    selectHeader: PropTypes.func,
    updateLoggedInAddress: PropTypes.func,
}

const mapStateToProps = (state, ownProps) => ({
    countryValue: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`,`${ownProps.contributionType}`,`${ownProps.accountId}`,"Donors",`${ownProps.donorId}`,"Address",'country']),
    isSameAddress: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`,`${ownProps.contributionType}`,`${ownProps.accountId}`,"Donors",`${ownProps.donorId}`,'isSameAddress']),
    dropdownVal : state.getIn(["makeAContribution","apiData","dropdownData","data"]),
});

export const mapDispatchToProps = (dispatch,ownProps) => ({
    selectHeader: data => dispatch(selectHeader(data)),
    updateLoggedInAddress: e => dispatch(updateLoggedinAddress({value: e, contributionType: ownProps.contributionType, assetHeld:ownProps.assetHeld, accountId: ownProps.accountId, donorId: ownProps.donorId })),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddressForm));